export default {
  'data.deleted': { $in: [false, null] },
  'data.is_bot': { $in: [false, null] },
  'data.is_restricted': { $in: [false, null] },
  'data.is_ultra_restricted': { $in: [false, null] },
  'data.id': { $ne: 'USLACKBOT' },
};
